import { render, staticRenderFns } from "./CascoCarInsurance.vue?vue&type=template&id=e3b2baf6"
import script from "./CascoCarInsurance.vue?vue&type=script&lang=ts"
export * from "./CascoCarInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports